import { DEBUG } from '@glimmer/env';
import WeakCache from './weak-cache';
const Cache = new WeakCache(DEBUG ? 'subscribers' : '');
Cache._generator = () => new Map();
const Tokens = new WeakCache(DEBUG ? 'identifier' : '');
export function unsubscribe(token) {
  let identifier = Tokens.get(token);
  if (!identifier) {
    throw new Error('Passed unknown unsubscribe token to unsubscribe');
  }
  Tokens.delete(token);
  const map = Cache.get(identifier);
  map?.delete(token);
}
/*
  Currently only support a single callback per identifier
*/
export default class NotificationManager {
  constructor(store) {
    this.store = store;
  }
  subscribe(identifier, callback) {
    let stableIdentifier = this.store.identifierCache.getOrCreateRecordIdentifier(identifier);
    let map = Cache.lookup(stableIdentifier);
    let unsubToken = {};
    map.set(unsubToken, callback);
    Tokens.set(unsubToken, stableIdentifier);
    return unsubToken;
  }
  notify(identifier, value, key) {
    let stableIdentifier = this.store.identifierCache.getOrCreateRecordIdentifier(identifier);
    let callbackMap = Cache.get(stableIdentifier);
    if (!callbackMap || !callbackMap.size) {
      return false;
    }
    callbackMap.forEach(cb => {
      cb(stableIdentifier, value, key);
    });
    return true;
  }
}